module.exports = __webpack_public_path__ + "img/headphone.490f1a47.jpeg";